import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import { useLocation, BrowserRouter as Router } from "react-router-dom";
import * as CreditActions from "../../store/credit/actions";
import { isIDFPartnerUser } from "../../util/partner";
import { useTranslation } from "react-i18next";
import * as LoginActions from "../../store/loginService/actions";
import LegalDocumentContainer from "../../components/LegalDocumentPages/LegalDocumentContainer";
const PSSPageFooter = () => {

    let currentPathLoc = useLocation();
    var currentPath = currentPathLoc.pathname.slice(13);
    const [pathLocation, setPathLocation] = useState("");

    useEffect(() => {
        currentPath = currentPath.replace("/", " | ");
        currentPath = currentPath.split("-").join(" ");
        currentPath = currentPath.replace(/(?:^|\s)\S/g, (res) => {
            return res.toUpperCase();
        });
        setPathLocation(currentPath);
    }, [currentPathLoc]);
    const dispatch = useDispatch();
    const requestCreditAuth = () => dispatch(CreditActions.actionCreators.requestValidateAuthentication());
    const legalDocUpdate = useSelector((state: ApplicationState) => {
        if (state.configurationState && state.configurationState.configuration && state.configurationState.configuration.partnerConfig) {
            return {
                termsAndConditionUpdated: state.configurationState.configuration.partnerConfig.termsAndCondtionsUpdated,
                privacyPolicyUpdated: state.configurationState.configuration.partnerConfig.privacyPolicyUpdated,
            };
        }
        return { termsAndConditionUpdated: false, privacyPolicyUpdated: false };
    });

    let authData = useSelector((state: ApplicationState) => {
        if (state.creditAuthData.authData != null) {
            let authStatus = state.creditAuthData.authData["auth-status"];
            return {
                isIDFUser: state.creditAuthData.authData.isIDFUser,
                authenticated: authStatus ? authStatus.toUpperCase() : "NONE",
                message: state.creditAuthData.authData.message,
            };
        }
        return { isIDFUser: "", authenticated: "", message: "" };
    });
    const { personalInformationLabel, personalInformationLink } = LegalDocumentContainer();
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );

    const partnerLegalName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.legalName
            ? state.configurationState.configuration.partnerConfig.legalName
            : "Sontiq"
    );

    const isShowSocialMediaLinks = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isShowSocialMediaLinks
            ? state.configurationState.configuration.partnerConfig.isShowSocialMediaLinks
            : false
    );

    const isWhiteLabeledEZSPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 540 || state.configurationState.configuration.partnerConfig.partnerId === 542
                ? true
                : false
            : false
    );

    const ensureDataFetched = () => {
        if (authData.authenticated === "AUTHENTICATED") {
            requestCreditAuth();
        }
    };

    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const phoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const doNotSellMyInformationLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.doNotSellMyInformationLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.doNotSellMyInformationLegalDocumentLink
            : ""
    );
    const termsOfUseLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLink
            : ""
    );
    const privacyPolicyLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLink
            : ""
    );
    //const commonDefinitionLegalDocumentLink: string = useSelector((state: ApplicationState) => state.configurationState && state.configurationState.configuration.partnerConfig.commonDefinitionLegalDocumentLink ? state.configurationState.configuration.partnerConfig.commonDefinitionLegalDocumentLink : "");
    const termsOfUseLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.termsOfUseLegalDocumentLabel
            : "Terms of Use"
    );

    const privacyPolicyLegalDocumentLabel: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            ? state.configurationState.configuration.partnerConfig.privacyPolicyLegalDocumentLabel
            : "Privacy Policy"
    );
    const trustCenterLegalDocumentLink: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.trustCenterLegalDocumentLink
            ? state.configurationState.configuration.partnerConfig.trustCenterLegalDocumentLink
            : ""
    );
    const isIDFPartner = useSelector((state: ApplicationState) =>
        state.configurationState &&
            state.configurationState.configuration.partnerConfig.partnerId &&
            state.configurationState.configuration.partnerConfig.isIdfPartner
            ? !isIDFPartnerUser(state.configurationState.configuration.partnerConfig.partnerId)
            : false
    );
    const [isLanguagePreferenceDialogOpen, setLanguagePreferenceDialogOpen] = useState(false);
    const selectedLang = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );
    const SetPreferencedLanguage = (leng: any, updateUsersLang: boolean) => dispatch(LoginActions.actionCreators.SetPreferencedLanguage(leng, updateUsersLang));
    const preferencedLanguage = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userInfo?.preferencedLanguage ? state.loggedInUser.userInfo?.preferencedLanguage : "en"
    );
    const letsGetstartedFlows = useSelector((state: ApplicationState) =>
        state.nextStepFlowState && state.nextStepFlowState.userLetsGetStartedFlows ? state.nextStepFlowState.userLetsGetStartedFlows : []
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const isDynamicFooterAvailable: boolean = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            ? state.configurationState.configuration.partnerConfig.isDynamicFooterAvailable
            : false
    );

    let language =
        !!partnerLanguageOptions && partnerLanguageOptions.length > 1
            ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                ? !!document.cookie
                    .split(";")
                    .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                    .split("=")[1]
                    ? document.cookie
                        .split(";")
                        .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                        .split("=")[1]
                    : "en"
                : "en"
            : "en";

    const openDoNotSellMyInformationPage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";

        if (isIDFPartner) {
            const urlToOpen = "https://www.sontiq.com/ccpa-addendum/";
            return urlToOpen;
        }
        if (doNotSellMyInformationLegalDocumentLink) {
            const urlToOpen = doNotSellMyInformationLegalDocumentLink.startsWith("/")
                ? base_url + doNotSellMyInformationLegalDocumentLink
                : doNotSellMyInformationLegalDocumentLink;
            return urlToOpen;
        }
        return base_url + "/ccpa";
    };

    const openTermsOfUsePage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (isIDFPartner) {
            const urlToOpen = "https://www.sontiq.com/terms-of-use/";
            return urlToOpen;
        }

        if (termsOfUseLegalDocumentLink) {
            const urlToOpen = termsOfUseLegalDocumentLink.startsWith("/") ? base_url + termsOfUseLegalDocumentLink : termsOfUseLegalDocumentLink;
            return urlToOpen;
        }
        return base_url + "/terms";
    };

    const openPrivacyPolicyPage = () => {
        const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + "/app";
        if (isIDFPartner) {
            const urlToOpen = "https://www.sontiq.com/privacy-policy/";
            return urlToOpen;
        }

        if (privacyPolicyLegalDocumentLink) {
            const urlToOpen = privacyPolicyLegalDocumentLink.startsWith("/") ? base_url + privacyPolicyLegalDocumentLink : privacyPolicyLegalDocumentLink;
            return urlToOpen;
        }

        return base_url + "/privacy";
    };
    const personalInfoWeCollect = () => {
        if (isDynamicFooterAvailable) {
            return (
                <li>
                    <a href={personalInformationLink} target="_blank">
                        <span className="nav-text">{personalInformationLabel}</span>
                    </a>
                </li>
            );
        }
    };

    //const openCommonDefinitionPage = (event: any) => {
    //    event.preventDefault();
    //    window.addToDataLayer({ event: 'Common Definition' })

    //    const base_url = decodeURIComponent(encodeURIComponent(window.location.origin)) + '/app';

    //    if (commonDefinitionLegalDocumentLink) {
    //        const urlToOpen = commonDefinitionLegalDocumentLink.startsWith('/') ? base_url + commonDefinitionLegalDocumentLink : commonDefinitionLegalDocumentLink;
    //        window.open(urlToOpen, '_blank');
    //        return;
    //    }

    //    window.open(base_url + '/common-definition', '_blank');
    //}

    const newTag = () => {
        return (
            <>
                <span className="new-label">New</span>
            </>
        );
    };

    const isPartnerIdIsNexshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 540
                ? true
                : false
            : false
    );
    const isPartnerIdIsGoezshield = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 36
                ? true
                : false
            : false
    );
    const isPartnerIdIsInfodefender = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 544
                ? true
                : false
            : false
    );
    const isHideCommonDefinitions = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isHideCommonDefinitions
            ? state.configurationState.configuration.partnerConfig.isHideCommonDefinitions === true
                ? true
                : false
            : false
    );
    const isPartnerIdMyDish = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 484
                ? true
                : false
            : false
    );
    const isPartnerIdADT = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2610
                ? true
                : false
            : false
    );
    return (
        <React.Fragment>
            {/*{!isPartnerIdIsGoezshield && (*/}
            <>
                {pathLocation === "PssSisk" ? (
                    <div id="pss6-footer">
                        <div className="l-page-container">
                            <div className="col-xs-12 col-sm flex-grow-null col-no-gutter pssfooter">
                                <ul>
                                    <li>
                                        {"© " + new Date().getFullYear() + " " + partnerLegalName.replace(".", "") + ". All rights reserved."}&nbsp;|&nbsp;
                                    </li>
                                    <li>Version 6.0.0.60&nbsp;|&nbsp;</li>
                                    {phoneNumber && phoneNumber.length > 0 && (<li>
                                        <a href={'tel:"' + phoneNumber + '"'}>{phoneNumber}</a>&nbsp;|&nbsp;
                                    </li>)}
                                    <li>
                                        <a href="https://www.sontiq.com/trust-center/"
                                            target="_blank"
                                            rel="noreferrer"
                                            onClick={() => {
                                                window.addToDataLayer({ event: "FooterTrustCenterLink" });
                                            }}>
                                            Trust Center
                                        </a>
                                        &nbsp;|&nbsp;
                                    </li>
                                    <li>
                                        <a href={openTermsOfUsePage()}
                                            target="_blank"
                                            rel="noreferrer"
                                            onClick={() => {
                                                window.addToDataLayer({ event: "Terms of Use" });
                                            }}>
                                            {termsOfUseLegalDocumentLabel}
                                            {legalDocUpdate.termsAndConditionUpdated && newTag()}
                                        </a>
                                        &nbsp;|&nbsp;
                                    </li>
                                    <li>
                                        <a href={openPrivacyPolicyPage()}
                                            target="_blank"
                                            rel="noreferrer"
                                            onClick={() => {
                                                window.addToDataLayer({ event: "Privacy Policy" });
                                            }}>
                                            {isIDFPartner ? "Privacy Notice" : privacyPolicyLegalDocumentLabel}
                                            {legalDocUpdate.privacyPolicyUpdated && newTag()}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : pathLocation === "FraudArmor" ? (
                    <div className="pss5footer_container relative">
                        <div className="footer_inner">
                            <div className="pss5mobileFooterLinks">
                                <a>
                                    Already Have an Account?
                                    <br />
                                    <a href="/app/login">Secure Log In</a>
                                </a>
                                <a href="javascript:void(0);" className="add-links">
                                    View Additional Links
                                </a>
                            </div>
                            <ul>
                                <li>
                                    <a href={decodeURIComponent(encodeURIComponent(window.location.href))} id="">
                                        <span>Home</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.fraudarmorservice.com/LegalDocuments/ConsumerServiceDescriptions/tabid/433/Default.aspx" id="">
                                        <span>Service Descriptions</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.fraudarmorservice.com/WhyUs/FAQ_Master_Page/tabid/378/Default.aspx" id="">
                                        <span>FAQs</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.fraudarmorservice.com/LegalDocuments/CommonDefinitions/tabid/436/Default.aspx" id="">
                                        <span>Common Definitions</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.fraudarmorservice.com/WhyUs/ContactUs/tabid/116/Default.aspx" id="">
                                        <span>Contact Us</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.fraudarmorservice.com/LegalDocuments/TermsAndConditions/tabid/434/Default.aspx" id="">
                                        <span>Terms And Conditions</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.fraudarmorservice.com/LegalDocuments/PrivacyPolicy/tabid/209/Default.aspx" id="">
                                        <span>Privacy Policy</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.fraudarmorservice.com/ReportFraud/tabid/122/Default.aspx" id="">
                                        <span>Report Fraud</span>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="copyright_bar">
                            &copy; {new Date().getFullYear()}
                            <span className="partnerCopyright"> {partnerLegalName.replace(".", "")}.&nbsp;&nbsp;All rights reserved.</span>&nbsp;&nbsp;|&nbsp;&nbsp;Version
                            6.0.0.60&nbsp;&nbsp;|&nbsp;&nbsp;
                            {phoneNumber && phoneNumber.length > 0 && (
                                <a href={'tel:"' + phoneNumber + '"'}>{phoneNumber}</a>
                            )}
                        </div>
                    </div>
                ) : (
                    <div id="pss-footer">
                        <div className={pathLocation == "ProvisionalResponseLandingPage1" || pathLocation == "ProvisionalResponseLandingPage2" ? "pssfooter-top" : pathLocation == "Aflac" || "AflacRegister" ? "pss7-pss-footer pssfooter-top" : "pssfooter-top"}>
                            <div className="l-page-container" style={{ paddingTop: 30 }}>
                                <div className={pathLocation == "ProvisionalResponseLandingPage1" || "ProvisionalResponseLandingPage2" ? "col-xs-12 col-sm flex-grow-null col-no-gutter pss1-footer pssfooter" : "col-xs-12 col-sm flex-grow-null col-no-gutter pssfooter"}>
                                    <ul>
                                        <li>
                                            {" "}
                                            {"© " + new Date().getFullYear() + " " + partnerLegalName.replace(".", "") + ". All rights reserved."}&nbsp;|&nbsp;
                                        </li>
                                        <li>Version 6.0.0.60&nbsp;|&nbsp;</li>
                                        {phoneNumber && phoneNumber.length > 0 && (<li>
                                            <a href={'tel:"' + phoneNumber + '"'}>{phoneNumber}</a>&nbsp;|&nbsp;
                                        </li>)}
                                        <li>
                                            {pathLocation == "CommerceBank" ? (
                                                ""
                                            ) : (
                                                <a href="https://www.sontiq.com/trust-center/" target="_blank">
                                                    Trust Center
                                                </a>
                                            )}
                                            &nbsp;|&nbsp;
                                        </li>
                                        {pathLocation == "CommerceBank" ? (
                                            <li>
                                                <a href="https://commercebank.ezshield.com/LegalDocuments/PrivacyPolicy/tabid/209/Default.aspx" target="_blank">
                                                    Terms & Conditions
                                                </a>
                                                &nbsp;|&nbsp;
                                            </li>
                                        ) :
                                            (<li>
                                                <a href="https://www.sontiq.com/terms-of-use/" target="_blank">
                                                    Terms of Use
                                                </a>
                                                &nbsp; |&nbsp;                                                    </li>
                                            )}
                                        <li>
                                            {pathLocation == "CommerceBank" ? (
                                                <a
                                                    href="https://commercebank.ezshield.com/DesktopModules/CgwHomePageInfo/Controls/LegalDocuments/TermsAndConditions/tabid/434/Default.aspx"
                                                    target="_blank"
                                                >
                                                    Privacy Policy{" "}
                                                </a>
                                            ) : (
                                                <a href="https://www.sontiq.com/privacy-policy/" target="_blank">
                                                    Privacy Notice
                                                </a>
                                            )}
                                            &nbsp;|&nbsp;
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {personalInfoWeCollect()}
            </>
            {/*)}*/}
        </React.Fragment>
    );
};
export default PSSPageFooter;
